import { combineReducers } from 'redux';
import recipeReducer from './recipes/reducer';
import articlesReducer from './articles/reducer';
import articleReducer from './recipe/reducer';
import partnerReducer from './partner/reducer';
import {reducer as toastrReducer} from 'react-redux-toastr';

export default combineReducers({
    recipes: recipeReducer,
    articles: articlesReducer,
    recipe: articleReducer,
    partner: partnerReducer,
    toastr: toastrReducer
    // truc: reducerTruc,
    // machin: combineReducers({
    //     machintruc: machintrucplop,
    //     machinchose: mokmrogkmog
    // })
});



// WEBPACK FOOTER //
// ./src/store/reducer.js